module.exports = __webpack_public_path__ + "static/6-ddae66e73ee8e9d1d3db63f7c0c57940.jpg";